<template>
  <div class="content">
    <div class="container-fluid">
      <div class="d-flex justify-content-center p-4">
        <card class="col-sm-8 col-xl-6">
          <div class="row">
            <div class="col-12 text-center mb-4">
              <h4>Logout</h4>
            </div>
          </div>
        </card>
      </div>
    </div>
  </div>
</template>

<script>
import Card from "src/components/Cards/Card";

export default {
  components: {
    Card
  },
  methods: {
    logout() {
        sessionStorage.removeItem("loginInfo");
        this.redirectAfter();
    },
    redirectAfter() {
      this.$router.push("/");
    },
  },
  mounted() {
    this.logout();
  },
};
</script>

<style lang="scss" scoped></style>
